import { StarIcon } from "@heroicons/react/24/outline";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";
import { ToggleButton } from "@heroui/react";
import { Controller, type Control } from "react-hook-form";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import { FilterFieldShell } from "./FilterFieldShell";

interface FavoritesFilterProps {
    control: Control<RecipesFilterFormValues>;
    onApply(): void;
}
export const FavoritesFilter = ({ control, onApply }: FavoritesFilterProps) => {
    return (
        <FilterFieldShell label="Favorites">
            <Controller
                name="isFavorite"
                control={control}
                render={({ field }) => (
                    <ToggleButton
                        className="filter-toggle filter-toggle--accent w-full justify-between"
                        variant="ghost"
                        isSelected={field.value}
                        onChange={(next) => {
                            field.onChange(next);
                            queueMicrotask(onApply);
                        }}
                        aria-label="Show favorites only"
                    >
                        {({ isSelected }) => (
                            <>
                                <span>{isSelected ? "Favorites only" : "Any"}</span>
                                {isSelected ? (
                                    <StarIconSolid className="w-4 h-4" />
                                ) : (
                                    <StarIcon className="w-4 h-4 text-default-500" />
                                )}
                            </>
                        )}
                    </ToggleButton>
                )}
            />
        </FilterFieldShell>
    );
};
